import { useMemo } from "react";
// import { useDeployedBalance } from "./useDeployedBalance";
import { useRedeemedBalance } from "./useRedeemedBalance";
import { useCardsCount } from "./useCardsCount";
import { useMerchantsCount } from "./useMerchantsCount";
import { useTerminalsCount } from "./useTerminalsCount";

export interface IssuerKpis {
  totalCards: number;
  totalMerchants: number;
  totalTerminals: number;
  // balanceDeployed: number;
  balanceRedeemed: number;
  /** Whether `balanceDeployed` is supply-minus-held (true) or the treasury's holding (false). */
  // deployedSupplyConfigured: boolean;
  /** Approximate USD value of the deployed figure. */
  // approxUsd: string;
  // loadingBalance: boolean;
  loadingRedeemedBalance: boolean;
  cardsCountLoading: boolean;
  merchantsCountLoading: boolean;
  terminalsCountLoading: boolean;
}

// TODO: replace with a live price feed, keyed by token once one is not 1:1.
// Both supported tokens are pegged 1:1 to the fiat unit — the same assumption the redeem path
// makes (amountInCents = round(amount * 100)) — so one rate is correct for either. It stops being
// correct the moment a non-pegged token is added, and then this has to become per-token.
// const TOKEN_TO_USD_RATE = 1;

// These arrive from `any`-typed axios responses, so a route answering with a different shape
// reaches JSX and React throws "Objects are not valid as a React child" — blanking the whole page
// over one tile. Degrade the tile and log loudly instead.
function asNumber(value: unknown, label: string): number {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (value === undefined || value === null) return 0;
  console.error(`useIssuerKpis: ${label} is not a number`, value);
  return 0;
}

export function useIssuerKpis(): IssuerKpis {
  // const { data: deployedBalance, isLoading: deployedBalanceLoading } =
  //   useDeployedBalance();
  const { data: redeemedBalance, isLoading: redeemedBalanceLoading } =
    useRedeemedBalance();
  const { data: cardsCount, isLoading: loadingCardsCount } = useCardsCount();
  const { data: merchantsCount, isLoading: loadingMerchantsCount } =
    useMerchantsCount();
  const { data: terminalsCount, isLoading: loadigTerminalsCount } =
    useTerminalsCount();
  return useMemo(() => {
    // A failed or empty count renders "0" rather than a blank card, and makes the declared
    // `number` return type honest — react-query hands back `number | undefined`.
    const totalCards = asNumber(cardsCount, "cardsCount");
    const totalMerchants = asNumber(merchantsCount, "merchantsCount");
    const totalTerminals = asNumber(terminalsCount, "terminalsCount");
    // const balanceDeployed = deployedBalance?.balance ?? 0;
    // const deployedSupplyConfigured = deployedBalance?.supplyConfigured ?? false;
    // const approxUsd = (balanceDeployed * TOKEN_TO_USD_RATE).toFixed(0);
    // const loadingBalance = deployedBalanceLoading;
    const balanceRedeemed = asNumber(redeemedBalance, "redeemedBalance");
    const loadingRedeemedBalance = redeemedBalanceLoading;
    const cardsCountLoading = loadingCardsCount;
    const merchantsCountLoading = loadingMerchantsCount;
    const terminalsCountLoading = loadigTerminalsCount;
    return {
      totalCards,
      totalMerchants,
      totalTerminals,
      // balanceDeployed,
      // deployedSupplyConfigured,
      balanceRedeemed,
      // approxUsd,
      // loadingBalance,
      loadingRedeemedBalance,
      cardsCountLoading,
      merchantsCountLoading,
      terminalsCountLoading,
    };
  }, [
    cardsCount,
    merchantsCount,
    loadingCardsCount,
    loadingMerchantsCount,
    // deployedBalance,
    // deployedBalanceLoading,
    redeemedBalance,
    redeemedBalanceLoading,
    loadigTerminalsCount,
    terminalsCount,
  ]);
}
